const SAFE_QUERY_PARAMETERS = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
  'make',
  'model',
  'radius',
  'page',
  'sort',
  'trim',
  'minYear',
  'maxYear',
  'minPrice',
  'maxPrice',
  'maxMileage',
]);

function normalizePathname(pathname) {
  if (/^\/car\/[^/]+(?:\/.*)?$/.test(pathname)) return '/car/:vehicle';
  if (/^\/lead\/[^/]+$/.test(pathname)) return '/lead/:token';
  if (/^\/chat\/[^/]+$/.test(pathname)) return '/chat/:token';
  if (/^\/dealer\/join\/[^/]+$/.test(pathname)) return '/dealer/join/:code';
  return pathname;
}

export function getAnalyticsPagePath(pathname, search = '') {
  const safeParams = new URLSearchParams();
  const params = new URLSearchParams(search);

  params.forEach((value, key) => {
    if (SAFE_QUERY_PARAMETERS.has(key)) safeParams.append(key, value);
  });

  const safeQuery = safeParams.toString();
  const safePathname = normalizePathname(pathname);
  return safeQuery ? `${safePathname}?${safeQuery}` : safePathname;
}
